module.exports = __webpack_public_path__ + "static/media/load-transactions.97f96df4.svg";